import { Helmet } from 'react-helmet-async';
import React from 'react';
import ProjectFormContainer from '../../containers/projects/ProjectFormContainer.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

const EditProject = ({ slug, projectId }) => {
  return (
    <>
      <Helmet>
        <title>Edit {getOrgTermsContent('project')} | ChangeSync</title>
      </Helmet>
      <ProjectFormContainer slug={slug} projectId={projectId} />
    </>
  );
};

EditProject.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(EditProject));
